<div class="row">
  <div class="col">
    <h1>Sorteos y Promociones</h1>
  </div>
</div>

<mat-tab-group>
  <mat-tab label="Sorteos">
    <giveaways-list></giveaways-list>
  </mat-tab>

  <mat-tab label="Promociones">
    Promociones
  </mat-tab>
</mat-tab-group>